<template>
  <div class="daiban-container">
    <van-nav-bar class="home-nav-bar" title=" 该模块火速开发中。。。" />
  </div>
</template>

<script>
export default {
  name: 'systemIndex',
  components: {
    
  },
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { 
    // this.init()
  },
  methods: {
     async init() {
      //修改主体框架标题
      document.title = "基础数据管理系统";
    },
  }
}
</script>

<style scoped lang='less'>
</style>